import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AccessibilityThemeService {
  private readonly storageKey = 'accessible-theme';

  constructor() {
    this.init();
  }

  init(): void {
    if (this.isEnabled()) {
      document.documentElement.setAttribute('data-theme', 'accessible');
    }
  }

  toggle(): void {
    if (this.isEnabled()) {
      document.documentElement.removeAttribute('data-theme');
      localStorage.removeItem(this.storageKey);
    } else {
      document.documentElement.setAttribute('data-theme', 'accessible');
      localStorage.setItem(this.storageKey, 'true');
    }
  }

  isEnabled(): boolean {
    return localStorage.getItem(this.storageKey) === 'true';
  }
}
